module.exports = __webpack_public_path__ + "static/media/Falcon329_4c.fa6fd54e.svg";